import { keyframes, style } from '@vanilla-extract/css';

const spin = keyframes({
  from: { transform: 'rotate(0deg)' },
  to: { transform: 'rotate(360deg)' },
});

export const playerWrapper = style({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  padding: '12px 0',
  borderRadius: '8px',
  width: '100%',
  boxSizing: 'border-box',
  height: 'fit-content',
});

/** Live render variant: tighter vertical padding between title and player row. */
export const playerWrapperCompactPadding = style({
  padding: '6px 0',
});

/** Write-mode email preview: player sits under title with no extra vertical padding. */
export const playerWrapperEmailTextColumn = style({
  gap: 0,
  padding: 0,
});

export const playerContent = style({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  minWidth: 0,
});

export const controlsRow = style({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
});

/** Space between static email-style PLAY pill and scrubber (write mode). */
export const controlsRowEmailReferenceGap = style({
  gap: '14px',
});

/**
 * Write-mode email preview: at sm+ tighten gaps (row stays flex so inline flex on the
 * controls row still matches email proportions via child flex-basis, without display:grid
 * overriding FOUC-safe inline styles in the iframe).
 */
export const controlsRowEmailReferenceColumns = style({
  '@media': {
    '(min-width: 640px)': {
      gap: 0,
    },
  },
});

export const emailPlayReferenceCell = style({
  display: 'flex',
  flexShrink: 0,
  minWidth: 0,
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: 'auto',
  '@media': {
    '(min-width: 640px)': {
      flexBasis: '8%',
      width: '8%',
      maxWidth: '8%',
    },
  },
});

/** Middle column: narrow spacer on mobile, 2% at sm+ (matches email column). */
export const emailPlayRowGutter = style({
  flexShrink: 0,
  width: '8px',
  minWidth: '8px',
  fontSize: '1px',
  lineHeight: '1px',
  '@media': {
    '(min-width: 640px)': {
      flexBasis: '2%',
      width: '2%',
      maxWidth: '2%',
      minWidth: 0,
    },
  },
});

/** Scrubber + timestamps: grows to fill remaining space. */
export const emailPlayProgressColumn = style({
  flex: '1 1 0%',
  minWidth: 0,
});

/** 28×28 play pill (matches email `PLAY_BUTTON_*` in podcast embed component). */
export const emailPlayReference = style({
  borderRadius: '14px',
  padding: '7px',
  width: '28px',
  height: '28px',
  boxSizing: 'border-box',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  userSelect: 'none',
});

export const controlButton = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2px',
  borderRadius: '50%',
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  transition: 'background-color 150ms',
  ':hover': {
    backgroundColor: 'rgba(128, 128, 128, 0.15)',
  },
  ':disabled': {
    opacity: 0.4,
    cursor: 'default',
  },
});

export const skipButton = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  padding: '2px',
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  transition: 'opacity 150ms',
  ':hover': {
    opacity: 0.7,
  },
  ':disabled': {
    opacity: 0.4,
    cursor: 'default',
  },
});

export const skipLabel = style({
  position: 'absolute',
  fontSize: '8px',
  fontWeight: 'bold',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  pointerEvents: 'none',
});

export const progressRow = style({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flex: 1,
});

export const timeLabel = style({
  fontSize: '12px',
  textAlign: 'center',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  opacity: 0.6,
});

export const progressBar = style({
  flex: 1,
  height: '8px',
  borderRadius: '9999px',
  overflow: 'hidden',
  cursor: 'pointer',
  backgroundColor: 'rgba(128, 128, 128, 0.3)',
});

export const progressFill = style({
  height: '100%',
  borderRadius: '9999px',
  transition: 'width 100ms linear',
});

export const playButtonWrapper = style({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const spinnerOverlay = style({
  position: 'absolute',
  inset: 0,
  borderRadius: '50%',
  border: '2px solid transparent',
  borderTopColor: 'currentColor',
  animation: `${spin} 0.8s linear infinite`,
  pointerEvents: 'none',
  opacity: 0.7,
});
